import { BaseRouteService } from 'core/services';

class ReferralRouteService extends BaseRouteService {
    constructor() {
        super('referrals');
    }

    invalidate(){
        return super.delete(this.base + '/invalidate');
    }

}

export default ReferralRouteService;
